import { queryOptions } from "@tanstack/react-query"
import { request } from "@utils/request"

type Bot = { id: string; name: string }

export const botsQuery = queryOptions({
  queryKey: ["va", "bots"],
  queryFn: () => request.get("api/va/bots/").json<Bot[]>(),
})
